<template>
  <div class="basicDataSummary">
    <div class="filters">
      <el-form :inline="true">
        <!-- 时间 -->
        <el-form-item>
          <el-date-picker v-model="datevalues" type="daterange" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')" :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <div class="topBox">
      <div class="topLeftBox">
        <el-card class="topLeftCard">
          <div class="cardTitle">基本信息&设备统计</div>
          <div class="topLeftInfo">
            <div class="leftFlex" @click="basicData.staffCount!=0 && goPropertyManageList()">
              <span class="lebelText">物业人数：</span>
              <p class="infoText" :class="basicData.staffCount!=0?'bb':''">{{basicData.staffCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.roomOwnerCount!=0 && goPreHouseholdInfoManageList()">
              <span class="lebelText">业主人数：</span>
              <p class="infoText" :class="basicData.roomOwnerCount!=0?'bb':''">{{basicData.roomOwnerCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">业主平均年龄：</span>
              <p class="infoText">
                {{basicData.gardenAge}}</p>
            </div>
            <div class="leftFlex" @click="basicData.appBindCount!=0 && goAppHouseholdManageList()">
              <span class="lebelText">APP绑定人数：</span>
              <p class="infoText" :class="basicData.appBindCount!=0?'bb':''">{{basicData.appBindCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.gardenGridCount!=0 && goCommunityInfoManageList()">
              <span class="lebelText">楼栋数：</span>
              <p class="infoText" :class="basicData.gardenGridCount!=0?'bb':''">{{basicData.gardenGridCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.gardenGateCount!=0 && goAccessControlEquipmentManagementList()">
              <span class="lebelText">园区出入口数量：</span>
              <p class="infoText" :class="basicData.gardenGateCount!=0?'bb':''">{{basicData.gardenGateCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.carPlaceCount!=0 && goCarUserList()">
              <span class="lebelText">车位数量：</span>
              <p class="infoText" :class="basicData.carPlaceCount!=0?'bb':''">{{basicData.carPlaceCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.gateCount!=0 && goCarPackList()">
              <span class="lebelText">车场出入口数量：</span>
              <p class="infoText" :class="basicData.gateCount!=0?'bb':''">{{basicData.gateCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.carInOutTmpPayAmount!=0 && goCarInOutTmpList()">
              <span class="lebelText">临时车缴费金额：</span>
              <p class="infoText" :class="basicData.carInOutTmpPayAmount!=0?'bb':''">
                {{basicData.carInOutTmpPayAmount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.venueCount!=0 && goVenueList()">
              <span class="lebelText">资源点位数量：</span>
              <p class="infoText" :class="basicData.venueCount!=0?'bb':''">
                {{basicData.venueCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.venueContractPrice!=0 && goContractList()">
              <span class="lebelText">资源点位收益金额：</span>
              <p class="infoText"
                :class="[basicData.venueContractPrice!=0?'bb':'',basicData.venueContractPrice>99999?'infoTextSmall':'']">
                {{basicData.venueContractPrice}}</p>
            </div>
            <div class="leftFlex" @click="basicData.maintainPrice!=0 && goProjectWideRepoInfoList(17)">
              <span class="lebelText">居家服务金额：</span>
              <p class="infoText" :class="basicData.maintainPrice!=0?'bb':''">
                {{basicData.maintainPrice}}</p>
            </div>
            <!-- <div class="leftFlex" style="opacity:0">
              <span class="lebelText"></span>
              <p class="infoText"></p>
            </div> -->
            <div class="leftFlex" @click="basicData.maintainCount!=0 && goProjectWideRepoInfoList('')">
              <span class="lebelText">工单总数：</span>
              <p class="infoText1" :class="basicData.maintainCount!=0?'bb1':''">{{basicData.maintainCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.maintainCountYear!=0 && goProjectWideRepoInfoList('')">
              <span class="lebelText">今年工单数：</span>
              <p class="infoText1" :class="basicData.maintainCountYear!=0?'bb1':''">{{basicData.maintainCountYear}}</p>
            </div>
            <div class="leftFlex" @click="basicData.maintainCountByUser!=0 && goRepoInfoList()">
              <span class="lebelText">业主报事总数：</span>
              <p class="infoText1" :class="basicData.maintainCountByUser!=0?'bb1':''">{{basicData.maintainCountByUser}}
              </p>
            </div>
            <div class="leftFlex" @click="basicData.maintainCountByUserYear!=0 && goRepoInfoList()">
              <span class="lebelText">今年业主报事数：</span>
              <p class="infoText1" :class="basicData.maintainCountByUserYear!=0?'bb1':''">
                {{basicData.maintainCountByUserYear}}</p>
            </div>
            <div class="leftFlex" @click="basicData.maintainCountByJob!=0 && goFullprojectAutoInspecRepoList()">
              <span class="lebelText">巡检工单总数：</span>
              <p class="infoText1" :class="basicData.maintainCountByJob!=0?'bb1':''">{{basicData.maintainCountByJob}}
              </p>
            </div>
            <div class="leftFlex" @click="basicData.maintainCountByJobYear!=0 && goFullprojectAutoInspecRepoList()">
              <span class="lebelText">今年巡检工单数：</span>
              <p class="infoText1" :class="basicData.maintainCountByJobYear!=0?'bb1':''">
                {{basicData.maintainCountByJobYear}}</p>
            </div>
            <div class="leftFlex" @click="basicData.deviceCount!=0 && goDeviceManagementList()">
              <span class="lebelText">设备总数：</span>
              <p class="infoText2" :class="basicData.deviceCount!=0?'bb2':''">{{basicData.deviceCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.liftCount!=0 && goLiftManagementList()">
              <span class="lebelText">电梯总数：</span>
              <p class="infoText2" :class="basicData.liftCount!=0?'bb2':''">{{basicData.liftCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.doorDeviceCount!=0 && goAccessControlEquipmentManagementList()">
              <span class="lebelText">蓝牙门禁数量：</span>
              <p class="infoText2" :class="basicData.doorDeviceCount!=0?'bb2':''">{{basicData.doorDeviceCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.liftDeviceCount!=0 && goElevBluetoothEquipManagesList()">
              <span class="lebelText">蓝牙梯控数量：</span>
              <p class="infoText2" :class="basicData.liftDeviceCount!=0?'bb2':''">{{basicData.liftDeviceCount}}</p>
            </div>
            <div class="leftFlex" @click="basicData.videoMonitorInterfaceCount!=0 && goHawkEyeOfParkList()">
              <span class="lebelText">园区鹰眼数量：</span>
              <p class="infoText2" :class="basicData.videoMonitorInterfaceCount!=0?'bb2':''">
                {{basicData.videoMonitorInterfaceCount}}</p>
            </div>
            <div class="leftFlex">
              <span class="lebelText">电梯费：</span>
              <p class="infoText2">
                {{basicData.liftAmount}}</p>
            </div>

          </div>
        </el-card>
      </div>
      <div class="topRightBox">
        <el-card class="topLeftCard mb20">
          <div class="cardTitle">月度工单统计</div>
          <div class="container">
            <div id="echart10"></div>
          </div>
        </el-card>
        <el-card class="topLeftCard mb20">
          <div class="cardTitle">{{year}}年{{month}}月工单统计</div>
          <div class="container">
            <div id="echart11"></div>
          </div>
        </el-card>
      </div>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">接单及时率统计</div>
        <div class="container">
          <div id="echart5"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">完结率统计</div>
        <div class="container">
          <div id="echart6"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">满意率统计</div>
        <div class="container">
          <div id="echart7"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">抢单及时率统计</div>
        <div class="container">
          <div id="echart18"></div>
        </div>
      </el-card>
      <el-card class="contentCard" style="flex: 2; padding-right: 50px;">
        <div class="cardTitle">工单类型统计</div>
        <div class="container h-300">
          <div id="echart4"></div>
        </div>
      </el-card>
      <!-- <el-card class="contentCard" style="opacity: 0;"></el-card> -->
    </div>
    <div class="contentBox">
      <el-card class="contentCard leftWidthBox">
        <div class="cardTitle">巡检工单完成率统计</div>
        <div class="container">
          <div id="echart15"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">普通报事完成率统计</div>
        <div class="container">
          <div id="echart16"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">业主报事完成率统计</div>
        <div class="container">
          <div id="echart17"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">本月接单排行榜</div>
        <div class="container h-300">
          <div id="echart8"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">本月报单排行榜</div>
        <div class="container h-300">
          <div id="echart9"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard leftWidthBox">
        <div class="cardTitle">物业费收取统计</div>
        <div class="container">
          <div id="echart1"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">车位费收取统计</div>
        <div class="container">
          <div id="echart2"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">临时车收费统计</div>
        <div class="container">
          <div id="echart13"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">当期物业费完成率</div>
        <div class="container">
          <div id="echart19"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">陈欠物业费完成率</div>
        <div class="container">
          <div id="echart20"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">当期车位费完成率</div>
        <div class="container">
          <div id="echart21"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">美邻家收入完成率</div>
        <div class="container">
          <div id="echart22"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">居家服务收入金额（元）</div>
        <div class="container">
          <div id="echart23"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">物业费日收费金额（元）</div>
        <div class="container">
          <div id="echart24"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">园区门禁通行流量统计</div>
        <div class="container">
          <div id="echart3"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">园区业主信息</div>
        <div class="container">
          <div id="echart12"></div>
        </div>
      </el-card>
      <el-card class="contentCard">
        <div class="cardTitle">App绑定率统计</div>
        <div class="container">
          <div id="echart14"></div>
        </div>
      </el-card>
    </div>
    <div class="contentBox">
      <el-card class="contentCard">
        <div class="cardTitle">管家管理数据统计</div>
        <div class="container">
          <el-table :data="staffGardenInfo" style="width: 94%" height="270">
            <el-table-column prop="IdNo" label="管家姓名">
            </el-table-column>
            <el-table-column prop="roomCount" label="管理户数">
            </el-table-column>
            <el-table-column prop="roomAvgAge" label="业主平均年龄">
            </el-table-column>
            <el-table-column label="当期物业费收费金额">
              <template slot-scope="scope">
                <span>{{scope.row.paidAmountCount}}</span>
              </template>
            </el-table-column>
            <el-table-column label="当期物业费收缴率">
              <template slot-scope="scope">
                <span>{{scope.row.thisPeriodRate}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="totalPrice" label="美邻家收入">
            </el-table-column>
            <el-table-column label="美邻家收入完成率">
              <template slot-scope="scope">
                <span>{{scope.row.completionRate}}%</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <!-- <el-card class="contentCard">
        
      </el-card>
      <el-card class="contentCard">
        
      </el-card> -->
    </div>
  </div>
</template>

<script>
  /**
   *@ClassName:basicDataSummary
   *@Description:基础数据汇总统计
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2022-11-9
   */
  // import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.basicDataSummary',
    data() {
      return {
        gardenId: this.$store.getters.gardenId, // 园区id
        basicData: {}, // 基础信息
        nowYear: new Date().getFullYear(), // 当前年份
        nowMonth: (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() +
          1, // 当前月份
        nowDay: new Date().getDate(), // 当前天
        year: '', // 工单统计点击年份
        month: '', // 工单统计点击月份
        maintainByMonthData: '', // 月度工单数据
        staffGardenInfo: [], // 管家管理list
        staffWyFeeData: [], // 管家物业费
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        datevalues: [], // 模糊查询起止时间
        startTs: '', // 开始时间
        endTs: '', // 结束时间
        timestamp: new Date().getTime() // 当前时间（查询收费统计表用）
      }
    },
    watch: {
      staffWyFeeData: {
        handler(newVal, oldVal) {
          for (let i = 0; i < newVal.length; i++) {
            for (let j = 0; j < this.staffGardenInfo.length; j++) {
              if (newVal[i].feeTypeCd == '888800010001' && newVal[i].staffId == this.staffGardenInfo[j].staffId) {
                this.$set(this.staffGardenInfo[j], 'paidAmountCount', newVal[i].paidAmountCount)
                this.$set(this.staffGardenInfo[j], 'thisPeriodRate', newVal[i].thisPeriodRate)
              }
            }
          }
        },
        deep: true,
        immediate: true
      }
    },
    created() {
      this.year = this.nowYear
      this.month = this.nowMonth
      this.getBasicData()
      this.getDeviceData()
      this.getPayInfowy()
      this.getPayInfocar()
      this.getDoorDeviceRecord()
      this.getMaintainType()
      this.getMaintainOverTime()
      this.getMaintainState()
      this.getMaintainEvaluate()
      this.getMaintainCountByRank()
      this.getMaintainByMonth()
      this.getSelectmaintainByDay(this.nowYear, this.nowMonth)
      this.getSelectstaffGardenInfo()
      this.getSelectcarInOutTmpByMouth()
      this.getBingRoomCount()
      this.getXjCompleteData()
      this.getPtCompleteData()
      this.getYzCompleteData()
      this.getMaintainOverMinute()
      this.getCurrentWyFee()
      this.getOweWyFee()
      this.getCurrentCwFee()
      this.getStaffCurrentWyFee()
      this.getHomeCarePrice()
      this.getFeeToday()
    },
    methods: {
      // 模糊查询
      commit() {
        if (this.datevalues != null && this.datevalues.length > 0) {
          this.startTs = this.datevalues[0]
          this.endTs = this.datevalues[1]
          this.timestamp = this.datevalues[0]
        } else {
          this.startTs = ''
          this.endTs = ''
          this.timestamp = new Date().getTime()
        }
        this.getBasicData()
        this.getPayInfowy()
        this.getMaintainType()
        this.getMaintainOverTime()
        this.getMaintainState()
        this.getMaintainEvaluate()
        this.getSelectstaffGardenInfo()
        this.getXjCompleteData()
        this.getPtCompleteData()
        this.getYzCompleteData()
        this.getMaintainOverMinute()
        this.getCurrentWyFee()
        this.getOweWyFee()
        this.getStaffCurrentWyFee()
        this.getCurrentCwFee()
        this.getHomeCarePrice()
        this.getFeeToday()
      },
      // 获取基本信息数据
      getBasicData() {
        let loading = this.$loading()
        this.$get(
          `/selectBasicData?gardenId=${this.gardenId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.$set(this.basicData, 'carPlaceCount', res.carPlaceCount)
              this.$set(this.basicData, 'gardenGridCount', res.gardenGridCount)
              this.$set(this.basicData, 'gateCount', res.gateCount)
              this.$set(this.basicData, 'maintainCount', res.maintainCount)
              this.$set(this.basicData, 'maintainCountByJob', res.maintainCountByJob)
              this.$set(this.basicData, 'maintainCountByUser', res.maintainCountByUser)
              this.$set(this.basicData, 'maintainCountYear', res.maintainCountYear)
              this.$set(this.basicData, 'maintainCountByJobYear', res.maintainCountByJobYear)
              this.$set(this.basicData, 'maintainCountByUserYear', res.maintainCountByUserYear)
              this.$set(this.basicData, 'roomOwnerCount', res.roomOwnerCount)
              this.$set(this.basicData, 'staffCount', res.staffCount)
              this.$set(this.basicData, 'gardenGateCount', res.gardenGateCount)
              this.$set(this.basicData, 'gardenAge', Math.round(res.gardenAge))
              this.$set(this.basicData, 'manCount', res.manCount)
              this.$set(this.basicData, 'womanCount', res.womanCount)
              this.$set(this.basicData, 'carInOutTmpPayAmount', res.carInOutTmpPayAmount)
              this.$set(this.basicData, 'maintainPrice', res.maintainPrice)
              this.$set(this.basicData, 'venueCount', res.venueCount)
              this.$set(this.basicData, 'venueContractPrice', res.venueContractPrice)
              this.$set(this.basicData, 'appBindCount', res.appBindCount)
              this.$set(this.basicData, 'liftAmount', res.liftAmount)
              this.getLoadEcharts12(Math.round(res.gardenAge), res.manCount, res.womanCount)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取设备信息数据
      getDeviceData() {
        let loading = this.$loading()
        this.$get(
          `/selectDeviceData?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.$set(this.basicData, 'deviceCount', res.deviceCount)
              this.$set(this.basicData, 'doorDeviceCount', res.doorDeviceCount)
              this.$set(this.basicData, 'liftCount', res.liftCount)
              this.$set(this.basicData, 'liftDeviceCount', res.liftDeviceCount)
              this.$set(this.basicData, 'videoMonitorInterfaceCount', res.videoMonitorInterfaceCount)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取物业缴费数据
      getPayInfowy() {
        let loading = this.$loading()
        this.$get(
          `/selectPayInfo?gardenId=${this.gardenId}&type=1&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.payInfo) {
                let data = []
                let isPay = {}
                let noPay = {}
                isPay.name = '实收'
                isPay.value = res.payInfo.paidAmountCount.toFixed(0)
                noPay.name = '未收'
                noPay.value = (res.payInfo.receiveAmountCount - res.payInfo.paidAmountCount).toFixed(0)
                if (isPay.value > 0) {
                  data.push(isPay)
                }
                if (noPay.value > 0) {
                  data.push(noPay)
                }
                this.getLoadEcharts1(data)
              } else {
                this.getLoadEcharts1(null)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取车位缴费数据
      getPayInfocar() {
        let loading = this.$loading()
        this.$get(
          `/selectPayInfo?gardenId=${this.gardenId}&type=2&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.payInfo) {
                let data = []
                let isPay = {}
                let noPay = {}
                isPay.name = '实收'
                isPay.value = res.payInfo.paidAmountCount.toFixed(0)
                noPay.name = '未收'
                noPay.value = (res.payInfo.receiveAmountCount - res.payInfo.paidAmountCount).toFixed(0)
                data.push(isPay)
                data.push(noPay)
                this.getLoadEcharts2(data)
              } else {
                this.getLoadEcharts2(null)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取园区门禁通行流量数据
      getDoorDeviceRecord() {
        let loading = this.$loading()
        this.$get(
          `/selectDoorDeviceRecord?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.data.length > 10) {
                let data = res.data.sort(function (a, b) {
                  return a.value > b.value ? 1 : -1
                })
                let arr = (data.reverse()).splice(0, 10)
                this.getLoadEcharts3(arr)
              } else if (res.data.length <= 10 && res.data.length > 1) {
                let data = res.data.sort(function (a, b) {
                  return a.value > b.value ? 1 : -1
                })
                let arr = data.reverse()
                this.getLoadEcharts3(arr)
              } else {
                this.getLoadEcharts3(res.data)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取工单类型统计数据
      getMaintainType() {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainTypeCount?gardenId=${this.gardenId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.data.length > 10) {
                let data = res.data.sort(function (a, b) {
                  return a.value > b.value ? 1 : -1
                })
                let arr = (data.reverse()).splice(0, 10)
                this.getLoadEcharts4(arr)
              } else if (res.data.length <= 10 && res.data.length > 1) {
                let data = res.data.sort(function (a, b) {
                  return a.value > b.value ? 1 : -1
                })
                let arr = data.reverse()
                this.getLoadEcharts4(arr)
              } else {
                this.getLoadEcharts4(res.data)
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单及时率数据
      getMaintainOverTime() {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainOverTime?gardenId=${this.gardenId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.getLoadEcharts5(res.data)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单完结率数据
      getMaintainState() {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainState?gardenId=${this.gardenId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.getLoadEcharts6(res.data)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单满意率数据
      getMaintainEvaluate() {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainEvaluate?gardenId=${this.gardenId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.getLoadEcharts7(res.data)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取接单报单排行榜数据
      getMaintainCountByRank() {
        let loading = this.$loading()
        this.$get(
          `/selectMaintainCountByRank?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              // res.putMaintainCountByRank // 接单排行榜
              // res.getMaintainCountByRank // 报单排行榜
              this.getLoadEcharts8(res.putMaintainCountByRank.slice(0, 5))
              this.getLoadEcharts9(res.getMaintainCountByRank.slice(0, 5))
              console.log(res)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取月度工单数据
      getMaintainByMonth() {
        let loading = this.$loading()
        this.$get(
          `/selectmaintainByMonth?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.maintainByMonthData = res.data
              this.maintainByMonthData1 = res.dataJob
              this.maintainByMonthData2 = res.dataUser
              let x = res.data.map(item => (
                item.name
              ))
              let y = res.data.map(item => (
                item.value
              ))
              let y1 = this.maintainByMonthData1.map(item => (
                (item.value).toFixed(2)
              ))
              let y2 = this.maintainByMonthData2.map(item => (
                (item.value).toFixed(2)
              ))
              this.getLoadEcharts10(x, y, y1, y2)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取具体月份工单数据
      getSelectmaintainByDay(y, m) {
        this.year = y
        this.month = m
        let loading = this.$loading()
        this.$get(
          `/selectmaintainByDay?gardenId=${this.gardenId}&m=` + y + `-` + m + `-01`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              let x = res.data.map(item => (
                item.date_y.slice(5)
              ))
              let y = res.data.map(item => (
                item.value
              ))
              let y1 = res.dataJob.map(item => (
                (item.value).toFixed(2)
              ))
              let y2 = res.dataUser.map(item => (
                (item.value).toFixed(2)
              ))

              if (m == this.nowMonth) {
                x = x.slice(0, this.nowDay)
                y = y.slice(0, this.nowDay)
                y1 = y1.slice(0, this.nowDay)
                y2 = y2.slice(0, this.nowDay)
              }
              this.getLoadEcharts11(x, y, y1, y2)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取管家管理数据
      getSelectstaffGardenInfo() {
        let loading = this.$loading()
        this.$get(
          `/selectstaffGardenInfo?gardenId=${this.gardenId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.staffGardenInfo = res.data
              // 美邻家收入
              let totalPrice = 0
              let targetAmount = 0

              this.staffGardenInfo.map(item => {
                if (item.totalPrice > 0 && item.targetAmount > 0) {
                  item.completionRate = ((item.totalPrice / item.targetAmount) * 100).toFixed(2)
                } else {
                  item.completionRate = 0
                }

                item.roomAvgAge = Math.round(item.roomAvgAge)
                var arr = item.IdNo.split('-')
                if (arr.length > 2) {
                  item.IdNo = arr[arr.length - 2] + '-' + arr[arr.length - 1]
                } else if (arr.length > 1) {
                  item.IdNo = arr[arr.length - 2] + '-' + arr[arr.length - 1]
                } else if (arr.length > 0) {
                  item.IdNo = arr[arr.length - 1]
                }
                totalPrice += item.totalPrice
                targetAmount += item.targetAmount
              })
              let data = [{
                  name: '已收取',
                  value: totalPrice.toFixed(2)
                },
                {
                  name: '未收取',
                  value: (targetAmount - totalPrice).toFixed(2)
                }
              ]
              this.getLoadEcharts22(data)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取临时车缴费数据
      getSelectcarInOutTmpByMouth() {
        let loading = this.$loading()
        this.$get(
          `/selectcarInOutTmpByMouth?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              let x = res.data.map(item => (
                item.name
              ))
              let y = res.data.map(item => (
                item.value
              ))
              this.getLoadEcharts13(x, y)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取App绑定率数据
      getBingRoomCount() {
        let loading = this.$loading()
        this.$get(
          `/selectBingRoomCount?gardenId=${this.gardenId}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              let arr = []
              let obj = {}
              let obj1 = {}
              obj.name = '已绑定'
              obj.value = res.data.bindRoomNum
              obj1.name = '未绑定'
              obj1.value = res.data.allRoomNum - res.data.bindRoomNum
              arr.push(obj)
              arr.push(obj1)
              console.log(arr)
              this.getLoadEcharts14(arr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取巡检工单完成率
      getXjCompleteData() {
        let loading = this.$loading()
        this.$get(
          `/selectMaintainFinishByType?gardenId=${this.gardenId}&isQuartzJob=1&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              let dataArr = res.data
              let nameArr = dataArr.map(item => item.maintainTypeName)
              let finishArr = dataArr.map(item => item.finishCount)
              let noFinishArr = dataArr.map(item => item.noFinishCount)
              this.getLoadEcharts15(nameArr, finishArr, noFinishArr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
        // let that = this
        // let dataArr = [{
        //     name: '工程',
        //     maintainCount: 121,
        //     finishCount: 79,
        //     noFinishCount: 42
        //   },
        //   {
        //     name: '客服',
        //     maintainCount: 100,
        //     finishCount: 86,
        //     noFinishCount: 14
        //   },
        //   {
        //     name: '秩序',
        //     maintainCount: 100,
        //     finishCount: 77,
        //     noFinishCount: 23
        //   },
        //   {
        //     name: '保洁',
        //     maintainCount: 2,
        //     finishCount: 1,
        //     noFinishCount: 1
        //   },
        //   {
        //     name: '绿化',
        //     maintainCount: 100,
        //     finishCount: 64,
        //     noFinishCount: 36
        //   },
        // ]
        // let nameArr = dataArr.map(item => item.name)
        // let finishArr = dataArr.map(item => item.finishCount)
        // let noFinishArr = dataArr.map(item => item.noFinishCount)
        // setTimeout(function () {
        //   that.getLoadEcharts15(nameArr, finishArr, noFinishArr)
        // }, 1000)
      },
      // 获取普通工单完成率
      getPtCompleteData() {
        let loading = this.$loading()
        this.$get(
          `/selectMaintainFinishByType?gardenId=${this.gardenId}&isNotQuartzJob=1&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              let dataArr = res.data
              let nameArr = dataArr.map(item => item.maintainTypeName)
              let finishArr = dataArr.map(item => item.finishCount)
              let noFinishArr = dataArr.map(item => item.noFinishCount)
              this.getLoadEcharts16(nameArr, finishArr, noFinishArr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取业主工单完成率
      getYzCompleteData() {
        let loading = this.$loading()
        this.$get(
          `/selectMaintainFinishByType?gardenId=${this.gardenId}&isUser=1&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              let dataArr = res.data
              let nameArr = dataArr.map(item => item.maintainTypeName)
              let finishArr = dataArr.map(item => item.finishCount)
              let noFinishArr = dataArr.map(item => item.noFinishCount)
              this.getLoadEcharts17(nameArr, finishArr, noFinishArr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取工单抢单及时率（1分钟抢单，15分钟抢单，超时）
      getMaintainOverMinute() {
        let loading = this.$loading()
        this.$get(
          `/selectMaintainInTime?gardenId=${this.gardenId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              let key1 = '1fen'
              let key2 = '15fen'
              let key3 = 'chaoshi'
              let val1
              let val2
              let val3
              let arr = []
              if (res.data && res.data[0] != null) {
                res.data.forEach(function (obj) {
                  val1 = obj[key1]
                  val2 = obj[key2]
                  val3 = obj[key3]
                })
                arr = [{
                    name: '1分钟抢单',
                    value: val1
                  },
                  {
                    name: '15分钟抢单',
                    value: val2
                  },
                  {
                    name: '超时',
                    value: val3
                  },
                ]
              }
              console.log(arr)
              this.getLoadEcharts18(arr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取当期物业费完成率
      getCurrentWyFee() {
        let loading = this.$loading()
        this.$get(
          `/selectCollectionRateDetail?gardenId=${this.gardenId}&period=${this.timestamp}&createTimeTs=&latitude=1&isWaiver=false`
        ).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              let arr = []
              let obj = {}
              res.list.map(item => {
                if (item.feeTypeCd == '888800010001') {
                  if (item.paidAmountCount && item.paidAmountCount) {
                    obj.name = '已收取'
                    obj.value = item.paidAmountCount
                    let obj1 = {}
                    obj1.name = '未收取'
                    obj1.value = (item.receiveAmountCount - item.paidAmountCount).toFixed(2) - 0
                    arr.push(obj)
                    arr.push(obj1)
                  }
                }
              })
              this.getLoadEcharts19(arr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取陈欠物业费完成率
      getOweWyFee() {
        let loading = this.$loading()
        this.$get(
          `/selectCollectionRateDetail?gardenId=${this.gardenId}&period=${this.timestamp}&createTimeTs=&latitude=1&isWaiver=false`
        ).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              let arr = []
              let obj = {}
              res.list.map(item => {
                if (item.feeTypeCd == '888800010001') {
                  if (item.paidAmountCount3 && item.paidAmountCount3) {
                    obj.name = '已收取'
                    obj.value = item.paidAmountCount3
                    let obj1 = {}
                    obj1.name = '未收取'
                    obj1.value = (item.receiveAmountCount3 - item.paidAmountCount3).toFixed(2) - 0
                    arr.push(obj)
                    arr.push(obj1)
                  }
                }
              })
              this.getLoadEcharts20(arr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取管家当期、陈欠物业费完成率
      getStaffCurrentWyFee() {
        let loading = this.$loading()
        this.$get(
          `/selectCollectionRateDetail?gardenId=${this.gardenId}&period=${this.timestamp}&createTimeTs=&latitude=3&isWaiver=false`
        ).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              this.staffWyFeeData = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取当期车位费完成率
      getCurrentCwFee() {
        const timestamp = new Date().getTime()
        let loading = this.$loading()
        this.$get(
          `/selectCollectionRateDetail?gardenId=${this.gardenId}&period=` + timestamp +
          `&createTimeTs=&latitude=1&isWaiver=false`
        ).then(
          res => {
            loading.close()
            console.log(res)
            if (res && res.errCode === 0) {
              let arr = []
              let obj = {}
              res.list.map(item => {
                if (item.feeTypeCd == '888800010009') {
                  if (item.paidAmountCount && item.receiveAmountCount) {
                    obj.name = '已收取'
                    obj.value = item.paidAmountCount
                    let obj1 = {}
                    obj1.name = '未收取'
                    obj1.value = (item.receiveAmountCount - item.paidAmountCount).toFixed(2) - 0
                    arr.push(obj)
                    arr.push(obj1)
                  }
                }
              })

              this.getLoadEcharts21(arr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取居家服务收入
      getHomeCarePrice() {
        let loading = this.$loading()
        this.$get(
          `/selectMaintainPriceList?gardenId=${this.gardenId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res.data)
              let arr = []
              if (this.startTs == '' && this.endTs == '' && res.data.length > 30) {
                arr = res.data.slice(-30)
              } else {
                arr = res.data
              }
              this.getLoadEcharts23(arr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 获取今日收取费用
      getFeeToday() {
        let loading = this.$loading()
        this.$get(
          `/selectFeeToday?gardenId=${this.gardenId}&startTs=${this.startTs}&endTs=${this.endTs}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res.data)
              let arr = []
              if (this.startTs == '' && this.endTs == '' && res.data.length > 30) {
                arr = res.data.slice(-30)
              } else {
                arr = res.data
              }
              console.log(arr)
              this.getLoadEcharts24(arr)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },

      // 获取物业费图表
      getLoadEcharts1(data) {
        if (!data) {
          var dom = document.getElementById('echart1')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart1 = this.$echarts.init(
            document.getElementById('echart1')
          )
          var option1 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#F97F51', '#6a89cc'],
            legend: {
              bottom: '0',
              left: '0'
            },
            series: [{
              name: '物业费收取统计',
              type: 'pie',
              radius: ['25%', '65%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  // formatter: '{b}:{c}({d}%)',
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      // return '{name|{b}}\n{value|{d}%( {c})}'
                      return text + '\n' + param.data.value + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '(' + param.percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data
            }]
          }
          myChart1.setOption(option1)
        }
      },
      // 获取车位费图表
      getLoadEcharts2(data) {
        if (!data) {
          var dom = document.getElementById('echart2')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart2 = this.$echarts.init(
            document.getElementById('echart2')
          )
          var option2 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#F97F51', '#6a89cc'],
            legend: {
              bottom: '0',
              left: '0'
            },
            series: [{
              name: '车位费收取统计',
              type: 'pie',
              radius: ['25%', '65%'],
              center: ['50%', '50%'],
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: true,
                  // formatter: '{b}:{c}({d}%)',
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      // return '{name|{b}}\n{value|{d}%( {c})}'
                      return text + '\n' + param.data.value + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '(' + param.percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 13
                  }
                }
              },
              data: data
            }]
          }
          myChart2.setOption(option2)
        }
      },
      // 园区门禁通行流量图表
      getLoadEcharts3(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart3')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart3 = this.$echarts.init(
            document.getElementById('echart3')
          )
          var option3 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#F97F51', '#6a89cc', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4', '#F97F51', '#6a89cc',
              '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4'
            ],
            series: [{
              name: '园区门禁通行流量统计',
              type: 'pie',
              radius: ['25%', '70%'],
              center: ['50%', '50%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}',
                  textStyle: {
                    fontSize: 14
                  },
                  overflow: 'break',
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          if (data.length <= 5) {
            option3.legend = {
              bottom: '0',
              left: '0'
            }
          }
          myChart3.setOption(option3)
        }
      },
      // 获取工单类型图表
      getLoadEcharts4(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart4')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 80
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart4 = this.$echarts.init(
            document.getElementById('echart4')
          )
          var option4 = {
            tooltip: {
              trigger: 'item'
            },
            color: ['#F97F51', '#6a89cc', '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4', '#F97F51', '#6a89cc',
              '#91CC75', '#FAC858', '#EE6666', '#73C0DE', '#9A60B4'
            ],
            series: [{
              name: '工单类型',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 11
                  },
                  overflow: 'none',
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          if (document.body.offsetWidth > 1600) {
            option4.legend = {
              bottom: '0',
              lfet: '0'
            }
          }
          myChart4.setOption(option4)
        }
      },
      // 获取接单及时率图表
      getLoadEcharts5(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart5')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart5 = this.$echarts.init(
            document.getElementById('echart5')
          )
          var option5 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc'],
            series: [{
              name: '接单率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart5.setOption(option5)
        }
      },
      // 获取完结率图表
      getLoadEcharts6(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart6')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart6 = this.$echarts.init(
            document.getElementById('echart6')
          )
          var option6 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc'],
            series: [{
              name: '完结率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart6.setOption(option6)
        }
      },
      // 获取满意率图表
      getLoadEcharts7(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart7')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart7 = this.$echarts.init(
            document.getElementById('echart7')
          )
          var option7 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc', '#91CC75', '#FAC858'],
            series: [{
              name: '满意率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: '{b}:{c}({d}%)',
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart7.setOption(option7)
        }
      },
      // 获取接单排行图表
      getLoadEcharts8(data) {
        console.log(data)
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart8')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          let nameList = data.map(item => {
            var arr = item.name.split('-')
            return arr[arr.length - 1]
          }).reverse()

          let maintainCountList = data.map(item => {
            return item.MaintainCount
          }).reverse()
          var myChart8 = this.$echarts.init(
            document.getElementById('echart8')
          )
          var option8 = {
            title: {

            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: ''
              }
            },
            legend: {},
            grid: {
              top: '0%',
              left: '3%',
              right: '5%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              minInterval: 1,
              boundaryGap: [0, 0.01],
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                }
              }
            },
            yAxis: {
              type: 'category',
              data: nameList,
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                }
              }
            },
            series: [{
              type: 'bar',
              barMaxWidth: 50,
              barWidth: '40%',
              data: maintainCountList,
              itemStyle: {
                normal: {
                  label: {
                    show: true, // 开启显示
                    position: 'right', // 在上方显示
                    textStyle: { // 数值样式
                      color: '5470c6',
                      fontSize: 16
                    }
                  },
                  color: {
                    type: 'linear',

                    colorStops: [{
                        offset: 0,
                        color: '#748ede',
                      },
                      {
                        offset: 1,
                        color: '#5470c6',
                      }
                    ]
                  },
                  barBorderRadius: [0, 3, 3, 0]
                },
                emphasis: {
                  color: '#748ede'
                }, // 鼠标悬停颜色
              },
            }, ]
          }
          myChart8.setOption(option8)
        }
      },
      // 获取报单排行图表
      getLoadEcharts9(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart9')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          let nameList = data.map(item => {
            var arr = item.name.split('-')
            return arr[arr.length - 1]
          }).reverse()

          let maintainCountList = data.map(item => {
            return item.MaintainCount
          }).reverse()
          var myChart9 = this.$echarts.init(
            document.getElementById('echart9')
          )
          var option9 = {
            title: {},
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: ''
              }
            },
            legend: {},
            grid: {
              top: '0%',
              left: '3%',
              right: '4%',
              bottom: '5%',
              containLabel: true
            },
            xAxis: {
              type: 'value',
              minInterval: 1,
              boundaryGap: [0, 0.01],
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                }
              }
            },
            yAxis: {
              type: 'category',
              data: nameList,
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                }
              }
            },
            series: [{
              type: 'bar',
              barMaxWidth: 50,
              barWidth: '40%',
              data: maintainCountList,
              itemStyle: {
                normal: {
                  label: {
                    show: true, // 开启显示
                    position: 'right', // 在上方显示
                    textStyle: { // 数值样式
                      color: '5470c6',
                      fontSize: 16
                    }
                  },
                  color: {
                    type: 'linear',

                    colorStops: [{
                        offset: 0,
                        color: '#748ede',
                      },
                      {
                        offset: 1,
                        color: '#5470c6',
                      }
                    ]
                  },
                  barBorderRadius: [0, 3, 3, 0]
                },
                emphasis: {
                  color: '#748ede'
                }, // 鼠标悬停颜色
              },
            }, ]
          }
          myChart9.setOption(option9)
        }
      },
      // 获取月度工单统计图表
      getLoadEcharts10(x, y, y1, y2) {
        let that = this
        var noData = y.every(item => item <= 0)
        if (noData) {
          var dom = document.getElementById('echart10')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 80
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart10 = this.$echarts.init(
            document.getElementById('echart10')
          )
          var option10 = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              top: '0',
              right: '40',
              padding: [0, 0, 10, 0]
            },
            grid: {
              top: '15%',
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: x,
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 14
                }
              }
            },
            yAxis: [{
                minInterval: 1,
                type: 'value',
                axisLabel: {
                  textStyle: {
                    color: '#5470c6',
                    fontSize: 16
                  },
                  formatter: '{value}'
                }
              },
              {
                type: 'value',
                splitLine: {
                  show: false
                },
                axisLabel: {
                  textStyle: {
                    color: '#ff6600',
                    fontSize: 16
                  },
                  formatter: '{value} 小时'
                }
              },
            ],
            series: [{
                name: '工单数',
                type: 'bar',
                barMaxWidth: 50,
                label: {
                  normal: {
                    formatter: function (params) {
                      if (params.value > 0) {
                        return params.value
                      } else {
                        return ''
                      }
                    },
                  }
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: document.body.offsetWidth > 1600, // 开启显示
                      position: 'top', // 在上方显示
                      textStyle: { // 数值样式
                        color: '#5470c6',
                        fontSize: 16
                      }
                    },
                    color: {
                      type: 'linear',
                      colorStops: [{
                          offset: 0,
                          color: '#748ede',
                        },
                        {
                          offset: 1,
                          color: '#5470c6',
                        }
                      ]
                    },
                    barBorderRadius: [8, 8, 0, 0]
                  }
                },
                data: y,
              },
              {
                name: '巡检工单平均用时',
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                  normal: {
                    color: '#ff6600',
                  }
                },
                // smooth: true,
                lineStyle: {
                  width: 2
                },
                data: y1
              },
              {
                name: '普通工单平均用时',
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                  normal: {
                    color: '#ffcc00',
                  }
                },
                // smooth: true,
                lineStyle: {
                  width: 2
                },
                data: y2
              }
            ]
          }
          myChart10.setOption(option10)
          myChart10.on('click', function (params) {
            let data = (that.maintainByMonthData.at(params.dataIndex).name).split('-')
            that.getSelectmaintainByDay(data[0], data[1])
          })
        }
      },
      // 获取具体月份工单统计图表
      getLoadEcharts11(x, y, y1, y2) {
        var noData = y.every(item => item <= 0)
        if (noData) {
          var dom = document.getElementById('echart11')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 80
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart11 = this.$echarts.init(
            document.getElementById('echart11')
          )
          var option11 = {
            tooltip: {
              trigger: 'axis',
              textStyle: {
                align: 'left'
              }
            },
            legend: {
              top: '0',
              right: '40',
              padding: [0, 0, 10, 0]
            },
            grid: {
              top: '15%',
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: x,
              axisLabel: {
                textStyle: {
                  color: '#55CCB9',
                  fontSize: 14
                }
              }
            },
            yAxis: [{
                minInterval: 1,
                type: 'value',
                splitLine: {
                  show: false
                },
                axisLabel: {
                  textStyle: {
                    color: '#55CCB9',
                    fontSize: 16
                  }
                }
              },
              {
                type: 'value',
                axisLabel: {
                  textStyle: {
                    color: '#ff6600',
                    fontSize: 16
                  },
                  formatter: '{value} 小时'
                }
              }
            ],
            series: [{
                name: '工单数',
                type: 'bar',
                barMaxWidth: 50,
                label: {
                  normal: {
                    formatter: function (params) {
                      if (params.value > 0) {
                        return params.value
                      } else {
                        return ''
                      }
                    },
                  }
                },
                itemStyle: {
                  normal: {
                    label: {
                      show: document.body.offsetWidth > 1600, // 开启显示
                      position: 'top', // 在上方显示
                      textStyle: { // 数值样式
                        color: '55CCB9',
                        fontSize: 16
                      }
                    },
                    color: {
                      type: 'linear',

                      colorStops: [{
                          offset: 0,
                          color: '#55CCB9',
                        },
                        {
                          offset: 1,
                          color: '#00CCA3',
                        }
                      ]
                    },
                    barBorderRadius: [5, 5, 0, 0]
                  }
                },
                data: y,
              }, {
                name: '巡检工单平均用时',
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                  normal: {
                    color: '#ff6600',
                  }
                },
                // smooth: true,
                lineStyle: {
                  width: 2
                },
                data: y1
              },
              {
                name: '普通工单平均用时',
                type: 'line',
                yAxisIndex: 1,
                itemStyle: {
                  normal: {
                    color: '#ffcc00',
                  }
                },
                // smooth: true,
                lineStyle: {
                  width: 2
                },
                data: y2
              }
            ]
          }
          myChart11.setOption(option11)
        }
      },
      // 获取园区平均年龄男女比例统计图表
      getLoadEcharts12(gardenAge, manCount, womanCount) {
        if (gardenAge == 1 && manCount == 0 && womanCount == 0) {
          var dom = document.getElementById('echart12')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          let data = []
          data.push({
            name: '男',
            value: manCount
          })
          data.push({
            name: '女',
            value: womanCount
          })
          var myChart12 = this.$echarts.init(
            document.getElementById('echart12')
          )
          var option12 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc'],
            series: [{
              name: '业主男女比例',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  // formatter: '{b}:{c}({d}%)',
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      // return '{name|{b}}\n{value|{d}%( {c})}'
                      return text + '\n' + param.data.value + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '(' + param.percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart12.setOption(option12)
        }
      },
      // 获取临时车缴费统计图表
      getLoadEcharts13(x, y) {
        var noData = y.every(item => item <= 0)
        if (noData) {
          var dom = document.getElementById('echart13')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 80
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart13 = this.$echarts.init(
            document.getElementById('echart13')
          )
          var option13 = {
            tooltip: {
              trigger: 'axis'
            },
            grid: {
              top: '10%',
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: x,
              axisLabel: {
                textStyle: {
                  color: '#8280e8',
                  fontSize: 14
                }
              }
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                textStyle: {
                  color: '#8280e8',
                  fontSize: 16
                }
              }
            },
            series: [{
              name: '临时车缴费金额',
              type: 'bar',
              barMaxWidth: 50,
              label: {
                normal: {
                  formatter: function (params) {
                    if (params.value > 0) {
                      return params.value
                    } else {
                      return ''
                    }
                  },
                }
              },
              itemStyle: {
                normal: {
                  label: {
                    show: document.body.offsetWidth > 1600, // 开启显示
                    position: 'top', // 在上方显示
                    textStyle: { // 数值样式
                      color: '8280e8',
                      fontSize: 16
                    }
                  },
                  color: {
                    type: 'linear',

                    colorStops: [{
                        offset: 0,
                        color: '#8280e8',
                      },
                      {
                        offset: 1,
                        color: '#6770ed',
                      }
                    ]
                  },
                  barBorderRadius: [5, 5, 0, 0]
                }
              },
              data: y,
            }]
          }
          myChart13.setOption(option13)
        }
      },
      // 获取App绑定率图表
      getLoadEcharts14(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart14')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart14 = this.$echarts.init(
            document.getElementById('echart14')
          )
          var option14 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#F97F51', '#6a89cc'],
            series: [{
              name: 'App绑定率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  // formatter: '{b}:{c}({d}%)',
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      // return '{name|{b}}\n{value|{d}%( {c})}'
                      return text + '\n' + param.data.value + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '(' + param.percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 12
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart14.setOption(option14)
        }
      },
      // 获取巡检工单完成率图表
      getLoadEcharts15(nameArr, finishArr, noFinishArr) {
        if (finishArr.length == 0 || !finishArr) {
          var dom = document.getElementById('echart15')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          const rawData = [
            finishArr,
            noFinishArr,
          ]
          const totalData = []
          for (let i = 0; i < rawData[0].length; ++i) {
            let sum = 0
            for (let j = 0; j < rawData.length; ++j) {
              sum += rawData[j][i]
            }
            totalData.push(sum)
          }
          const grid = {
            top: '15%',
            left: '3%',
            right: '4%',
            bottom: '10%',
          }
          const series = [{
              name: '已完成',
              type: 'bar',
              stack: 'total',
              barWidth: '40%',
              barMaxWidth: 50,
              label: {
                show: true,
                position: 'inside',
                formatter: (params) => {
                  const originalValue = rawData[0][params.dataIndex]
                  const percentage = (originalValue / totalData[params.dataIndex] * 100).toFixed(2)
                  if (originalValue > 0) {
                    return `${percentage}% \n(${originalValue})`
                  } else {
                    return ''
                  }
                },
              },
              itemStyle: {
                color: '#91CC75' // 设置颜色
              },
              data: rawData[0].map((d, did) =>
                totalData[did] <= 0 ? 0 : d / totalData[did]
              )
            },
            {
              name: '未完成',
              type: 'bar',
              stack: 'total',
              barWidth: '60%',
              barMaxWidth: 50,
              label: {
                show: true,
                position: 'inside',
                formatter: (params) => {
                  const originalValue = rawData[1][params.dataIndex]
                  const percentage = (originalValue / totalData[params.dataIndex] * 100).toFixed(2)
                  return `${percentage}% \n(${originalValue})`
                },
              },
              itemStyle: {
                color: '#F97F51' // 设置颜色
              },
              data: rawData[1].map((d, did) =>
                totalData[did] <= 0 ? 0 : d / totalData[did]
              )
            },
          ]
          var myChart15 = this.$echarts.init(
            document.getElementById('echart15')
          )
          var option15 = {
            legend: {
              selectedMode: false,
              right: 0,
              top: 0
            },
            grid,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              },
              formatter: (params) => {
                const total = totalData[params[0].dataIndex]
                const header = `<div style="font-weight:bold">${params[0].axisValue}</div>
                      <div>总数: ${total}</div>`
                const body = params.map(param => {
                  const originalValue = rawData[param.seriesIndex][param.dataIndex]
                  const percentage = (originalValue / total * 100).toFixed(2)
                  return `<div>${param.seriesName}: ${originalValue} (${percentage}%)</div>`
                }).join('')
                return header + body
              }
            },
            yAxis: {
              type: 'value'
            },
            xAxis: {
              type: 'category',
              axisLabel: {
                interval: nameArr.length > 20 ? 1 : 0,
              },
              data: nameArr
            },
            series
          }
          myChart15.setOption(option15)
        }
      },
      // 获取普通工单完成率图表
      getLoadEcharts16(nameArr, finishArr, noFinishArr) {
        if (finishArr.length == 0 || !finishArr) {
          var dom = document.getElementById('echart16')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          const rawData = [
            finishArr,
            noFinishArr,
          ]
          const totalData = []
          for (let i = 0; i < rawData[0].length; ++i) {
            let sum = 0
            for (let j = 0; j < rawData.length; ++j) {
              sum += rawData[j][i]
            }
            totalData.push(sum)
          }
          const grid = {
            top: '15%',
            left: '3%',
            right: '4%',
            bottom: '10%',
          }
          const series = [{
              name: '已完成',
              type: 'bar',
              stack: 'total',
              barWidth: '60%',
              barMaxWidth: 50,
              label: {
                show: true,
                position: 'inside',
                formatter: (params) => {
                  const originalValue = rawData[0][params.dataIndex]
                  const percentage = (originalValue / totalData[params.dataIndex] * 100).toFixed(2)
                  // return `${percentage}% \n(${originalValue})`
                  if (originalValue > 0) {
                    return `${percentage}% \n(${originalValue})`
                  } else {
                    return ''
                  }
                },
              },
              itemStyle: {
                color: '#91CC75' // 设置颜色
              },
              data: rawData[0].map((d, did) =>
                totalData[did] <= 0 ? 0 : d / totalData[did]
              )
            },
            {
              name: '未完成',
              type: 'bar',
              stack: 'total',
              barWidth: '60%',
              barMaxWidth: 50,
              label: {
                show: true,
                position: 'inside',
                formatter: (params) => {
                  const originalValue = rawData[1][params.dataIndex]
                  const percentage = (originalValue / totalData[params.dataIndex] * 100).toFixed(2)
                  return `${percentage}% \n(${originalValue})`
                },
              },
              itemStyle: {
                color: '#F97F51' // 设置颜色
              },
              data: rawData[1].map((d, did) =>
                totalData[did] <= 0 ? 0 : d / totalData[did]
              )
            },
          ]
          var myChart16 = this.$echarts.init(
            document.getElementById('echart16')
          )
          var option16 = {
            legend: {
              selectedMode: false,
              right: 0,
              top: 0
            },
            grid,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              },
              formatter: (params) => {
                const total = totalData[params[0].dataIndex]
                const header = `<div style="font-weight:bold">${params[0].axisValue}</div>
                      <div>总数: ${total}</div>`
                const body = params.map(param => {
                  const originalValue = rawData[param.seriesIndex][param.dataIndex]
                  const percentage = (originalValue / total * 100).toFixed(2)
                  return `<div>${param.seriesName}: ${originalValue} (${percentage}%)</div>`
                }).join('')
                return header + body
              }
            },
            yAxis: {
              type: 'value'
            },
            xAxis: {
              type: 'category',
              axisLabel: {
                interval: nameArr.length > 10 ? 1 : 0,
                // rotate: nameArr.length > 10 ? 45 : 0
              },
              data: nameArr
            },
            series
          }
          myChart16.setOption(option16)
        }
      },
      // 获取巡检工单完成率图表
      getLoadEcharts17(nameArr, finishArr, noFinishArr) {
        if (finishArr.length == 0 || !finishArr) {
          var dom = document.getElementById('echart17')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          const rawData = [
            finishArr,
            noFinishArr,
          ]
          const totalData = []
          for (let i = 0; i < rawData[0].length; ++i) {
            let sum = 0
            for (let j = 0; j < rawData.length; ++j) {
              sum += rawData[j][i]
            }
            totalData.push(sum)
          }
          const grid = {
            top: '15%',
            left: '3%',
            right: '4%',
            bottom: '10%',
          }
          const series = [{
              name: '已完成',
              type: 'bar',
              stack: 'total',
              barWidth: '60%',
              barMaxWidth: 50,
              label: {
                show: true,
                position: 'inside',
                formatter: (params) => {
                  const originalValue = rawData[0][params.dataIndex]
                  const percentage = (originalValue / totalData[params.dataIndex] * 100).toFixed(2)
                  // return `${percentage}% \n(${originalValue})`
                  if (originalValue > 0) {
                    return `${percentage}% \n(${originalValue})`
                  } else {
                    return ''
                  }
                },
              },
              itemStyle: {
                color: '#91CC75' // 设置颜色
              },
              data: rawData[0].map((d, did) =>
                totalData[did] <= 0 ? 0 : d / totalData[did]
              )
            },
            {
              name: '未完成',
              type: 'bar',
              stack: 'total',
              barWidth: '60%',
              barMaxWidth: 50,
              label: {
                show: true,
                position: 'inside',
                formatter: (params) => {
                  const originalValue = rawData[1][params.dataIndex]
                  const percentage = (originalValue / totalData[params.dataIndex] * 100).toFixed(2)
                  return `${percentage}% \n(${originalValue})`
                },
              },
              itemStyle: {
                color: '#F97F51' // 设置颜色
              },
              data: rawData[1].map((d, did) =>
                totalData[did] <= 0 ? 0 : d / totalData[did]
              )
            },
          ]
          var myChart17 = this.$echarts.init(
            document.getElementById('echart17')
          )
          var option17 = {
            legend: {
              selectedMode: false,
              right: 0,
              top: 0
            },
            grid,
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              },
              formatter: (params) => {
                const total = totalData[params[0].dataIndex]
                const header = `<div style="font-weight:bold">${params[0].axisValue}</div>
                      <div>总数: ${total}</div>`
                const body = params.map(param => {
                  const originalValue = rawData[param.seriesIndex][param.dataIndex]
                  const percentage = (originalValue / total * 100).toFixed(2)
                  return `<div>${param.seriesName}: ${originalValue} (${percentage}%)</div>`
                }).join('')
                return header + body
              }
            },
            yAxis: {
              type: 'value'
            },
            xAxis: {
              type: 'category',
              axisLabel: {
                interval: nameArr.length > 10 ? 1 : 0,
              },
              data: nameArr
            },
            series
          }
          myChart17.setOption(option17)
        }
      },
      // 获取抢单及时率图表
      getLoadEcharts18(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart18')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart18 = this.$echarts.init(
            document.getElementById('echart18')
          )
          var option18 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#91CC75', '#6a89cc', '#F97F51'],
            series: [{
              name: '抢单及时率统计',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      return text + '\n' + param.data.value + '\n' + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '\n' + '(' + param
                        .percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart18.setOption(option18)
        }
      },
      // 获取当期物业费完成率图表
      getLoadEcharts19(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart19')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart19 = this.$echarts.init(
            document.getElementById('echart19')
          )
          var option19 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#91CC75', '#6a89cc'],
            series: [{
              name: '当期物业费完成率',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      return text + '\n' + param.data.value + '\n' + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '\n' + '(' + param
                        .percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart19.setOption(option19)
        }
      },
      // 获取陈欠物业费完成率图表
      getLoadEcharts20(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart20')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart20 = this.$echarts.init(
            document.getElementById('echart20')
          )
          var option20 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              right: '0',
            },
            color: ['#91CC75', '#6a89cc'],
            series: [{
              name: '陈欠物业费完成率',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      return text + '\n' + param.data.value + '\n' + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '\n' + '(' + param
                        .percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart20.setOption(option20)
        }
      },
      // 获取当期车位费完成率图表
      getLoadEcharts21(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart21')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart21 = this.$echarts.init(
            document.getElementById('echart21')
          )
          var option21 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#91CC75', '#6a89cc'],
            series: [{
              name: '当期车位费完成率',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      return text + '\n' + param.data.value + '\n' + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '\n' + '(' + param
                        .percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart21.setOption(option21)
        }
      },
      // 获取美邻家收入完成率图表
      getLoadEcharts22(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart22')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          var myChart22 = this.$echarts.init(
            document.getElementById('echart22')
          )
          var option22 = {
            tooltip: {
              trigger: 'item'
            },
            legend: {
              bottom: '0',
              left: '0'
            },
            color: ['#91CC75', '#6a89cc'],
            series: [{
              name: '美邻家收入完成率',
              type: 'pie',
              radius: ['25%', '70%'],
              label: {
                normal: {
                  show: true,
                  formatter: function (param) {
                    console.log('text', param)
                    let text = param.data.name
                    if (text.length < 15) {
                      return text + '\n' + param.data.value + '\n' + '(' + param.percent + '%)'
                    } else {
                      return text.substring(0, 15) + '...' + '\n' + param.data.value + '\n' + '(' + param
                        .percent +
                        '%)'
                    }
                  },
                  textStyle: {
                    fontSize: 14
                  }
                }
              },
              data: data,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          }
          myChart22.setOption(option22)
        }
      },
      // 获取接单排行图表
      getLoadEcharts23(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart23')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          let nameList = data.map(item => {
            // var arr = item.name.split('-')
            // return arr[arr.length - 1]
            return item.name
          })

          let valueList = data.map(item => {
            return item.value
          })
          var myChart23 = this.$echarts.init(
            document.getElementById('echart23')
          )
          var option23 = {
            title: {

            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: ''
              }
            },
            legend: {},
            grid: {
              top: '5%',
              left: '3%',
              right: '5%',
              bottom: '5%',
              containLabel: true
            },
            yAxis: {
              type: 'value',
              minInterval: 1,
              boundaryGap: [0, 0.01],
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                }
              }
            },
            xAxis: {
              type: 'category',
              data: nameList,
              axisLabel: {
                textStyle: {
                  color: '#5470c6',
                  fontSize: 16
                }
              }
            },
            series: [{
              type: 'bar',
              barMaxWidth: 50,
              data: valueList,
              itemStyle: {
                normal: {
                  label: {
                    show: true, // 开启显示
                    position: 'top', // 在上方显示
                    textStyle: { // 数值样式
                      color: '5470c6',
                      fontSize: 16
                    }
                  },
                  color: {
                    type: 'linear',

                    colorStops: [{
                        offset: 0,
                        color: '#748ede',
                      },
                      {
                        offset: 1,
                        color: '#5470c6',
                      }
                    ]
                  },
                  barBorderRadius: [3, 3, 0, 0]
                },
                emphasis: {
                  color: '#748ede'
                }, // 鼠标悬停颜色
              },
            }, ]
          }
          myChart23.setOption(option23)
        }
      },
      // 获取今日收费金额图表
      getLoadEcharts24(data) {
        if (data.length == 0 || !data) {
          var dom = document.getElementById('echart24')
          dom.innerHTML = ' 暂无数据 ╮(╯▽╰)╭'
          var height = dom.offsetHeight - 30
          dom.style.cssText = 'font-size:20px;color:#999;text-align:center;line-height:' + height + 'px'
          dom.removeAttribute('_echarts_instance_')
        } else {
          let nameList = data.map(item => {
            // var arr = item.name.split('-')
            // return arr[arr.length - 1]
            return item.name
          })

          let valueList = data.map(item => {
            return item.value
          })
          var myChart24 = this.$echarts.init(
            document.getElementById('echart24')
          )
          var option24 = {
            title: {

            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: ''
              }
            },
            legend: {},
            grid: {
              top: '5%',
              left: '3%',
              right: '5%',
              bottom: '5%',
              containLabel: true
            },
            yAxis: {
              type: 'value',
              minInterval: 1,
              boundaryGap: [0, 0.01],
              axisLabel: {
                textStyle: {
                  color: '#55CCB9',
                  fontSize: 16
                }
              }
            },
            xAxis: {
              type: 'category',
              data: nameList,
              axisLabel: {
                textStyle: {
                  color: '#55CCB9',
                  fontSize: 16
                }
              }
            },
            series: [{
              type: 'bar',
              barMaxWidth: 50,
              data: valueList,
              itemStyle: {
                normal: {
                  label: {
                    show: true, // 开启显示
                    position: 'top', // 在上方显示
                    textStyle: { // 数值样式
                      color: '#55CCB9',
                      fontSize: 12
                    }
                  },
                  color: {
                    type: 'linear',
                    colorStops: [{
                        offset: 0,
                        color: '#55CCB9',
                      },
                      {
                        offset: 1,
                        color: '#00CCA3',
                      }
                    ]
                  },
                  barBorderRadius: [3, 3, 0, 0]
                },
                emphasis: {
                  color: '#00CCA3'
                }, // 鼠标悬停颜色
              },
            }, ]
          }
          myChart24.setOption(option24)
        }
      },

      // 跳转物业人员管理
      goPropertyManageList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('物业人员管理')
        if (index != -1) {
          this.$router.push({
            name: 'propertyManageList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转原始住户数据管理
      goPreHouseholdInfoManageList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('原始住户数据管理')
        if (index != -1) {
          this.$router.push({
            name: 'preHouseholdInfoManageList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转app住户管理
      goAppHouseholdManageList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('APP住户管理')
        if (index != -1) {
          this.$router.push({
            name: 'appHouseholdManageList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转小区信息管理
      goCommunityInfoManageList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('小区信息管理')
        if (index != -1) {
          this.$router.push({
            name: 'communityInfoManageList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转车场管理
      goCarPackList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('车场管理')
        if (index != -1) {
          this.$router.push({
            name: 'carPackList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转车辆管理
      goCarUserList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('车辆管理')
        if (index != -1) {
          this.$router.push({
            name: 'carUserList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转全项目报事信息
      goProjectWideRepoInfoList(num) {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('全项目报事信息')
        if (index != -1) {
          this.$router.push({
            name: 'projectWideRepoInfoList',
            query: {
              firstLevelid: num
            }
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转报事信息
      goRepoInfoList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('报事信息')
        if (index != -1) {
          this.$router.push({
            name: 'repoInfoList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转全项目自动巡检报事
      goFullprojectAutoInspecRepoList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('全项目自动巡检报事')
        if (index != -1) {
          this.$router.push({
            name: 'fullprojectAutoInspecRepoList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转设备管理
      goDeviceManagementList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('设备管理')
        if (index != -1) {
          this.$router.push({
            name: 'deviceManagementList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转电梯管理
      goLiftManagementList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('电梯管理')
        if (index != -1) {
          this.$router.push({
            name: 'liftManagementList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转门禁设备管理
      goAccessControlEquipmentManagementList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('门禁设备管理')
        if (index != -1) {
          this.$router.push({
            name: 'accessControlEquipmentManagementList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },

      // 跳转电梯蓝牙设备管理
      goElevBluetoothEquipManagesList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('电梯蓝牙设备管理')
        if (index != -1) {
          this.$router.push({
            name: 'elevBluetoothEquipManagesList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },

      // 跳转园区鹰眼
      goHawkEyeOfParkList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('园区鹰眼')
        if (index != -1) {
          this.$router.push({
            name: 'hawkEyeOfParkListNew'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转临时车出入记录
      goCarInOutTmpList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('临时车出入记录')
        if (index != -1) {
          this.$router.push({
            name: 'carInOutTmpList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转资源点位管理
      goVenueList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('资源点位管理')
        if (index != -1) {
          this.$router.push({
            name: 'venueList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
      // 跳转资源点位合同管理
      goContractList() {
        var userMunuList = JSON.stringify(this.$store.getters.userMunuList)
        var index = userMunuList.indexOf('合同管理')
        if (index != -1) {
          this.$router.push({
            name: 'contractList'
          })
        } else {
          this.$message.info('暂无查看详情权限')
        }
      },
    }
  }
</script>

<style lang="scss">
  .basicDataSummary {
    .mb20 {
      margin-bottom: 20px;
    }

    .h-300 {
      height: 300px !important;
    }

    .h-380 {
      height: 380px !important;
    }

    .cardTitle {
      font-size: 18px;
      padding-left: 10px;
      margin-left: 10px;
      margin-bottom: 30px;
      border-left: 3px solid #ff6207;
    }

    .topBox {
      display: flex;

      .topLeftBox {
        flex: 1;
        min-width: 520px;
        margin-right: 20px;

        .cardTitle {
          font-size: 18px;
          padding-left: 10px;
          margin-left: 10px;
          margin-bottom: 30px;
          border-left: 3px solid #ff6207;
        }

        .topLeftInfo {
          width: 100%;
          display: flex;
          flex-wrap: wrap;

          .leftFlex {
            flex: 1 47%;
            display: flex;
            background-color: #f5f5f5;
            border-radius: 5px;
            margin: 0 10px 10px 0;
            padding: 6px 10px;
            box-sizing: border-box;
            align-items: center;

            .lebelText {
              font-size: 16px;
              flex: 1;
            }

            .infoText {
              padding: 0 5px;
              text-align: right;
              font-size: 28px;
              color: #00b1c3;
              margin-right: 15px;
            }

            .infoText1 {
              padding: 0 5px;
              text-align: right;
              font-size: 28px;
              color: #b4d049;
              margin-right: 15px;
            }

            .infoText2 {
              padding: 0 5px;
              text-align: right;
              font-size: 28px;
              color: #ed8599;
              margin-right: 15px;
            }

            .infoTextSmall {
              font-size: 20px;
            }

            .bb {
              border-bottom: 3px solid #00b1c3;
            }

            .bb1 {
              border-bottom: 3px solid #b4d049;
            }

            .bb2 {
              border-bottom: 3px solid #ed8599;
            }
          }
        }

        .topLeftInfo::after {
          flex: 1 50%;
          content: '';
        }
      }

      .topRightBox {
        flex: 2;

        .container {
          width: 100%;
          height: 292px;
          margin-left: 30px;
        }
      }
    }

    .contentBox {
      display: flex;
      margin-bottom: 20px;

      .contentCard {
        flex: 1;
        margin-right: 20px;
      }

      .contentCard:last-child {
        margin-right: 0;
      }

      .container {
        width: 100%;
        height: 280px;
        margin-left: 30px;
      }

      .gardenAge {
        margin-left: 24px;
        font-size: 18px;
        font-weight: bold;
        color: #999;

        span {
          font-size: 30px;
          color: #F97F51;
        }
      }
    }

    #echart1,
    #echart2,
    #echart3,
    #echart4,
    #echart5,
    #echart6,
    #echart7,
    #echart8,
    #echart9,
    #echart10,
    #echart11,
    #echart12,
    #echart13,
    #echart14,
    #echart15,
    #echart16,
    #echart17,
    #echart18,
    #echart19,
    #echart20,
    #echart21,
    #echart22,
    #echart23,
    #echart24,
      {
      width: 90%;
      height: 100%;
    }
  }
</style>